export const game112PlayersD1 = [
  {
    display: "BakaTai",
    id: "BakaTai",
    img: "https://i.imgur.com/twkLNXE.png",
  },
  {
    display: "Margi",
    id: "Margi",
    img: "https://i.imgur.com/3M1lmeX.png",
  },
  {
    display: "Grysun",
    id: "Grysun",
    img: "https://i.imgur.com/yRMXGUG.png",
  },
  {
    display: "Erinyes",
    id: "Erinyes",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "Tatsu",
    id: "Tatsu",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "DigitalDude",
    id: "DigitalDude",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "Gajeel",
    id: "Gajeel",
    img: "https://i.imgur.com/kV7Dwgr.png",
  },
  {
    display: "Shad",
    id: "Shad",
    img: "https://i.imgur.com/OIsWUCh.png",
  },
  {
    display: "James",
    id: "James",
    img: "https://via.placeholder.com/64x64.png",
  },
  {
    display: "Brandish",
    id: "Brandish",
    img: "https://i.imgur.com/YaNAo2v.png",
  },
  {
    display: "Sam",
    id: "Sam",
    img: "https://i.imgur.com/M8wKIIJ.png",
  },
  {
    display: "GB",
    id: "GB",
    img: "https://i.imgur.com/VRvv9at.png",
  },
  {
    display: "Marmalade",
    id: "Marmalade",
    img: "https://i.imgur.com/VRvv9at.png",
  },
  {
    display: "Holt",
    id: "Holt",
    img: "https://i.imgur.com/VRvv9at.png",
  }
];
